app.service('hashChecker', function () {

	let hash = {
		value: null,
		setUp() {
			this.value = document.location.hash;
		},
		isEmpty() {
			return !this.value;
		},
		equals(hash) {
			return this.value === hash;
		},
		contains(hash) {
			return this.value.indexOf(hash) > -1;
		}
	};

	function check(storeDispatchCallback) {
		hash.setUp();

		if (hash.isEmpty()) return false;

		if (hash.equals("#raty")) {
			storeDispatchCallback('setDefaultContext');
			return true;
		}

		if (hash.equals("#outlet") || hash.equals("#outlet-offer") || hash.contains("#afterSearch-outlet")) {
			storeDispatchCallback('setDefaultOutlet');
			return true;
		}

		if (hash.contains("|raty")) { // np. #outlet-dobry|raty
			let linkName = getOutletLinkNameFromHash();
			storeDispatchCallback('setOutletByLinkNameWithDefaultContext', {linkName});
			return true;
		}

		if (hash.contains("#outlet-")) { // #np. #outlet-dobry
			let linkName = getOutletLinkNameFromHash();
			if(linkName === "outlet-dostateczny") return false;
			
			storeDispatchCallback('setOutletByLinkName', {linkName});
			return true;
		}

		return false;
	}

	function getOutletLinkNameFromHash() {
		const regexp = /^#(outlet-[a-z]+)/g;
		let result = regexp.exec(hash.value);
		return result ? result[1] : false;
	}

	return {
		check
	};
});
